import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Skeleton, useMediaQuery, useTheme } from "@mui/material";
import { headingFonts } from "../../../Styles/Styles";
import { useNavigate } from "react-router-dom";

// Register Doughnut chart elements
ChartJS.register(ArcElement, Tooltip, Legend);

const TotalChats = () => {
  const [chartData, setChartData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/charts/total-chats-stats`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (response.status === 401) {
          setError("Unauthorized. Please log in.");
          navigate("/get-started");
          return;
        }

        if (response.status === 403) {
          setError("Access denied.");
          return;
        }

        const data = await response.json();

        const totalChats = data.totalChats;

        setChartData({
          labels: ["Chats Started"],
          datasets: [
            {
              label: "Chats",
              data: [totalChats],
              backgroundColor: [
                "rgba(255, 206, 86, 0.6)", // Chats
                "rgba(201, 203, 207, 0.3)", // Remaining
              ],
              borderColor: ["rgba(255, 206, 86, 1)", "rgba(201, 203, 207, 1)"],
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching chat stats:", error);
        setError("An error occurred while fetching chat data.");
      }
    };

    fetchStats();
  }, [navigate]);

  return (
    <div style={{ width: "100%", padding: isMobile ? "10px" : "20px" }}>
      <h4 style={{ ...headingFonts, textAlign: "center" }}>
        Total Chats Started
      </h4>

      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}

      {!chartData && !error ? (
        <Skeleton variant="rectangular" width="100%" height={400} />
      ) : (
        <Doughnut
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: {
                position: "bottom",
                align: "center",
                labels: {
                  font: { family: "ClashGrotesk-Medium" },
                  letterSpacing: 1,
                },
              },
            },
          }}
          style={{
            maxHeight: isMobile ? "300px" : "400px",
            margin: "0 auto",
          }}
        />
      )}
    </div>
  );
};

export default TotalChats;
